/**
 * Graph Group node (camera-in-blueprint Phase 3) — a self-contained sub-graph, stored inline
 * on the node exactly like `stateMachine` does (data.innerNodes / data.innerEdges). No
 * exec/data pins in v1 — it is purely an authoring container; double-click drills in via the
 * same drill-in chrome as the Function editor (see EventGraph.jsx's GroupEditor).
 */

const ACCENT      = '#4fc0c8'
const BORDER_IDLE = '#123840'
const BG_IDLE     = '#04141a'
const BG_SEL      = '#082026'

export function GraphGroupNode({ data, selected }) {
  const innerNodes = data.innerNodes ?? []
  const count = innerNodes.length

  return (
    <div
      onDoubleClick={e => { e.stopPropagation(); data.onOpenGroup?.() }}
      style={{
        background: selected ? BG_SEL : BG_IDLE,
        border: `2px solid ${selected ? ACCENT : BORDER_IDLE}`,
        borderRadius: 8,
        padding: '10px 16px',
        minWidth: 190,
        color: '#ddd',
        fontFamily: 'var(--m-font)',
        fontSize: 12,
        cursor: 'default',
        userSelect: 'none',
        boxShadow: selected ? `0 0 12px ${ACCENT}22` : 'none',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <span style={{ fontSize: 13 }}>▣</span>
        <span style={{ color: ACCENT, fontWeight: 'bold', fontSize: 10, letterSpacing: 1 }}>
          GRAPH GROUP
        </span>
      </div>

      {/* Editable name */}
      <input
        value={data.name ?? 'Graph Group'}
        onChange={e => data.onChange?.('name', e.target.value)}
        onMouseDown={e => e.stopPropagation()}
        onDoubleClick={e => e.stopPropagation()}
        style={{
          width: '100%', boxSizing: 'border-box',
          background: 'transparent', border: 'none',
          borderBottom: '1px solid #123840',
          color: '#cfeef2', fontWeight: 'bold', fontSize: 13,
          fontFamily: 'var(--m-font)', outline: 'none',
          padding: '1px 0', marginBottom: 6,
        }}
      />

      {/* Inner-node count */}
      <div style={{ color: '#2a4a50', fontSize: 10, marginBottom: 4 }}>
        {count === 0 ? 'empty — double-click to add nodes' : `${count} node${count !== 1 ? 's' : ''} inside`}
      </div>

      {/* Double-click hint */}
      <div style={{ color: '#1e3238', fontSize: 9, fontStyle: 'italic' }}>
        double-click to open
      </div>
    </div>
  )
}
